import classNames from 'classnames';
import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import { TripState } from '../../../types/trips/Trips';
import s from './TripStateIndicatorInbox.module.scss';

type Props = {
  tripState: TripState;
};

const TripStateIndicatorInbox: FC<Props> = ({
  tripState,
}) => (
  <li className={getClassName(s, 'root', classNames(tripState?.state))}>
    {tripState?.badge ?? ''}
  </li>
);

export default TripStateIndicatorInbox;
